import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PendingChangesGuard} from './shared/pending-changes.guard';
import {NotFoundComponent} from './not-found/not-found.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {LoginComponent} from './login/login.component';
import {LogoutComponent} from './logout/logout.component';
import {ProfileComponent} from './profile/profile.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'user-management',
    loadChildren: () => import('./user-management/user-management.module').then(a => a.UserManagementModule)
  },
  {
    path: 'smarticle-controlling',
    loadChildren: () => import('./smarticle-controlling/smarticle-controlling.module').then(a => a.SmarticleControllingModule)
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then(a => a.MessagesModule)
  },
  {
    path: 'video-help',
    loadChildren: () => import('./video-help/video-help.module').then(a => a.VideoHelpModule)
  },
  {
    path: 'onboarding-wizard',
    loadChildren: () => import('./onboarding-wizard/onboarding-wizard.module').then(a => a.OnboardingWizardModule)
  },
  {
    path: 'default-translations',
    loadChildren: () => import('./default-translations/default-translations.module').then(a => a.DefaultTranslationsModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(a => a.DashboardModule)
  },
  {
    path: 'website-modules',
    loadChildren: () => import('./website-modules/website-modules.module').then(a => a.WebsiteModulesModule)
  },
  {
    path: 'clipping-dashboard',
    loadChildren: () => import('./clipping-dashboard/clipping-dashboard.module').then(a => a.ClippingDashboardModule)
  },
  {
    path: 'app-creator-config',
    loadChildren: () => import('./app-creator-config/app-creator-config.module').then(a => a.AppCreatorConfigModule)
  },
  {
    path: 'app-creator',
    loadChildren: () => import('./app-creator/app-creator.module').then(a => a.AppCreatorModule)
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
